// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"47":"46ad6ea1","72":"3c8acf29","118":"01a98a26","170":"c24b57e9","237":"84d91437","870":"01d2f001","893":"85458797","949":"ff292208"}[chunkId] + ".js";
};